import { Injectable } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Paths } from '../../enums/paths.enum';
import { flushState } from '../../state/app.state.actions';
import { ResetStoreService } from './resetStore.service';

const CURRENT_VERSION = '26.1.0';

@Injectable({
    providedIn: 'root',
})
export class VersionManagementService {
    constructor(
        private store: Store,
        private resetStoreService: ResetStoreService,
        private router: Router,
        private readonly auth: Auth,
    ) { }

    public checkVersionAndUpdate(): void {
        const localStorageVersion = localStorage.getItem('appVersion');
        const currentLanguage = localStorage.getItem('currentLanguage');

        if (localStorage == null || localStorageVersion !== CURRENT_VERSION) {
            // Flush NgRx store and localStorage
            this.store.dispatch(flushState());
            this.resetStoreService.resetAllStores();
            localStorage.clear();
            // Update localStorage with the new version
            localStorage.setItem('appVersion', CURRENT_VERSION);
            // // navigate to overview
            if (this.auth.currentUser) {
                this.router.navigateByUrl(`${currentLanguage}/${Paths.HOME}/${Paths.PROJECT}`);
            }
        }
    }
}
